import { api } from "../../services/api";

/** Whether the Keepo is PLUS already (asks the API again, skipping the cached list). */
export const isPlus = async (siteId: string) => {
  api.clearCacheSites();
  const sites = await api.getSites().catch(() => []);
  return sites.find(item => item.siteId === siteId)?.subscription?.type === "PLUS";
};

/**
 * Waits for the Keepo to turn PLUS: Stripe tells the API once the payment went through (webhook), which can
 * take a few seconds. Checked every `intervalMs`, up to `tries` times.
 */
export const waitForPlus = async (siteId: string, { intervalMs = 2000, tries = 30 } = {}) => {
  for (let attempt = 0; attempt < tries; attempt++) {
    if (await isPlus(siteId)) {
      return true;
    }
    await new Promise(resolve => window.setTimeout(resolve, intervalMs));
  }
  return false;
};
